var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedFileBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 0.5C1.23122 0.5 0 1.73122 0 3.25V17.25C0 18.7688 1.23122 20 2.75 20H7V18.5H2.75C2.05964 18.5 1.5 17.9404 1.5 17.25V3.25C1.5 2.55964 2.05964 2 2.75 2H10V6.39705C10 6.81126 10.3358 7.14705 10.75 7.14705H14V10V10.5H15.5V10V6.4479C15.5 6.08178 15.3852 5.72488 15.1717 5.42745L12.1585 1.22955C11.8298 0.771573 11.3006 0.5 10.7368 0.5H2.75Z",
    fill: "#323338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7143 11.5754C11.8911 11.4749 12.1089 11.4749 12.2857 11.5754L15.7143 13.5876C15.8911 13.6881 16 13.8738 16 14.0748V17.9252C16 18.1262 15.8911 18.3119 15.7143 18.4124L12.2857 20.4246C12.1089 20.5251 11.8911 20.5251 11.7143 20.4246L8.28571 18.4124C8.10891 18.3119 8 18.1262 8 17.9252V14.0748C8 13.8738 8.10891 13.6881 8.28571 13.5876L11.7143 11.5754ZM14.164 15.0327C14.3263 14.8679 14.3263 14.6008 14.164 14.4361C14.0017 14.2713 13.7386 14.2713 13.5763 14.4361L11.3766 16.669L10.4237 15.7017C10.2614 15.5369 9.9983 15.5369 9.83601 15.7017C9.67371 15.8664 9.67371 16.1336 9.83601 16.2983L11.0828 17.5639C11.1607 17.6431 11.2664 17.6875 11.3766 17.6875C11.4868 17.6875 11.5925 17.6431 11.6705 17.5639L14.164 15.0327Z",
    fill: "#00A859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedFileBlue);
export default __webpack_public_path__ + "static/media/verified-file-blue.a7c8c01e839cbd59b6f6f8421f4337fc.svg";
export { ForwardRef as ReactComponent };